import PageCommon from "../PageCommon.js";
import Pqp from "../../3x1010/Pqp.js";
import * as Solr from "../../3x1010/Solr.js";
import QueryBuilder from "./ctrl/QueryBuilder.js";
import AbstractWidgetToggler from "../../components/common/abstract/AbstractWidgetToggler.js";
import DialogSaveQuery from "../../components/common/DialogSaveQuery.component.js";
import WrapperIO from "./utils/WrapperIO.js";
import DialogLoadQuery from "../../components/common/DialogLoadQuery.component.js";
import ResultViewer from "./results/ResultViewer.js";
//import TreeViewer from "./tree/TreeViewer.js";

export default class PageSolrAdvanced extends PageCommon {
  constructor() {
    super();
    this.lastQueryUid = null;
    this.lastQueryName = "";
    this.lastDescName = "";
  }

  doSearch(terms, collection, field = null) {
    const rv = new ResultViewer();
    rv.search(terms, collection, field);
  }

  /*createTree() {
    const tree = new TreeViewer(jQuery(".js-table-tree"), jQuery(".js-tree-data-content"));
    tree.init();
  }*/

  init($data) {
    super.init($data);
    this.showPreloader(false);
    Pqp.trace("PageSolrAdvanced - Hello world");

    // dispaccio un evento globale
    try {
      this.dispatchInitEvent(TheDisp.EV_PAGETHIS_INITED);
    } catch (error) {
      // console.log(error);
    }
    // Collezione di default
    //this.collectionName = "FOTOTECA_coll";
    //this.collectionName = "ARCHIVI_coll";
    //this.collectionName = "APPARECCHI_coll";
    //this.collectionName = "MANIFESTI_coll";
    //this.collectionName = "FILMOGRAFIA_coll";
    //this.collectionName = "MEMORABILIA_coll";
    //this.collectionName = "MISCELLANEA_coll";
    //this.collectionName = "CINETECA_coll";
    //this.collectionName = "ARCHEOLOGIADELCINEMA_coll";
    this.collectionName = Solr.Schema.getDefaultCollectionName();
    console.log(this.collectionName);

    this.setSimpleOrComplexMode();
    this.initQueryBuilder();
    //this.initTableTree();
    this.setButtons();
    //this.createTree();
    //this.setFullTextSearch();
    // Controlla nel local storage la modalità di visualizzazione e se ne null lo setta a true
  }

  setSimpleOrComplexMode() {
    if (PageSolrAdvanced.SHOW_SIMPLE_MODE_TOGGLER) {
      if (localStorage.getItem("simpleMode") === null) {
        localStorage.setItem("simpleMode", "true");
      }
      localStorage.getItem("simpleMode") === "true" ? (QueryBuilder.SIMPLE_MODE = true) : (QueryBuilder.SIMPLE_MODE = false);
      jQuery(".js-cta-toggle-simple").on("click", this.toggleSimpleMode.bind(this));
      this.checkSimpleMode();
      jQuery(".js-cta-toggle-simple").css("pointer-events", "all");
      jQuery(".js-cta-toggle-simple").css("opacity", "1");
    } else {
      QueryBuilder.SIMPLE_MODE = true;
      jQuery(".js-cta-toggle-simple").css("pointer-events", "none");
      jQuery(".js-cta-toggle-simple").css("opacity", "0");
    }
  }

  toggleSimpleMode() {
    QueryBuilder.SIMPLE_MODE = !QueryBuilder.SIMPLE_MODE;
    localStorage.setItem("simpleMode", QueryBuilder.SIMPLE_MODE);
    this.checkSimpleMode();
    this.qb.dispose();
    this.initQueryBuilder();
  }

  checkSimpleMode() {
    if (QueryBuilder.SIMPLE_MODE) {
      jQuery(".js-cta-toggle-simple").addClass("is-active");
    } else {
      jQuery(".js-cta-toggle-simple").removeClass("is-active");
    }
  }

  initQueryBuilder(query = null) {
    this.qb = new QueryBuilder(QueryBuilder.QUERY_NERA, jQuery(".js-query-chunks"), this.collectionName, query, this.queryBuilderEventsHandler.bind(this));
    this.qb.init();
  }

  queryBuilderEventsHandler(e) {
    if (e.type == QueryBuilder.EVENT_CHANGE_COLLECTION) {
      const notImplemented = [];
      if (notImplemented.includes(e.data)) {
        alert("Non l'ho ancora fatta questa collezione!");
        this.qb.update();
      } else {
        this.collectionName = e.data;
        this.qb.dispose();
        this.initQueryBuilder();
      }
    }
  }

  /*initTableTree() {
    const tableTreeCont = new AbstractWidgetToggler({
      btn: document.querySelector(".js-btn-toggle-table"),
      target: document.querySelector(".js-table-tree-cont"),
      activeClass: "is-open",
    });
    tableTreeCont.init();
  }*/

  onTrySearch() {
    const rv = new ResultViewer();
    rv.searchAdvanced(this.qb);
  }

  setButtons() {
    jQuery(".js-try-search").on("click", this.onTrySearch.bind(this));
    jQuery(".js-load").on("click", this.onCtaLoad.bind(this));
    jQuery(".js-save").on("click", this.onCtaSave.bind(this));
    this.updateLoad();
  }

  onCtaLoad() {
    this.showPreloader(true);
    WrapperIO.getQueries(this.wrapperIOHandler.bind(this));
  }

  onCtaSave() {
    this.dialog = new DialogSaveQuery(".js-dialog-save-query", this.handleDialogSaveEvents.bind(this));
    this.dialog.init(this.lastQueryUid, this.lastQueryName, this.lastDescName);
    this.dialog.show();
  }

  handleDialogSaveEvents(res) {
    if (res) {
      this.lastQueryUid = res.uid;
      this.lastQueryName = res.name;
      this.lastDescName = res.desc;
      this.showPreloader(true);
      WrapperIO.saveQuery(this.qb, res, this.wrapperIOHandler.bind(this));
    }
  }

  wrapperIOHandler(e) {
    if (e.type === WrapperIO.EVENT_SAVED_SUCCESS) {
      this.lastQueryUid = e.uid;
      this.showPreloader(false);
      this.updateLoad();
    }
    if (e.type === WrapperIO.EVENT_SAVED_ERROR) {
      this.showPreloader(false);
      this.updateLoad();
    }
    if (e.type === WrapperIO.EVENT_LOAD_SUCCESS) {
      this.showPreloader(false);
      this.dialog = new DialogLoadQuery(".js-dialog-load-query", this.handleDialogLoadEvents.bind(this));
      this.dialog.init(e.queries);
      this.dialog.show();
    }
  }

  handleDialogLoadEvents(res) {
    if (res) {
      this.lastQueryUid = res.Uid;
      this.lastQueryName = res.Name;
      this.lastDescName = res.Description;
      const query = JSON.parse(res.Query);
      this.collectionName = query.CollectionName;
      const q = Solr.QueryWrapper.fromJsonObject(query);
      this.qb.dispose();
      this.initQueryBuilder(q);
    }
  }

  updateLoad() {
    if (WrapperIO.hasSaves()) {
      jQuery(".js-load").removeClass("is-disabled");
    } else {
      jQuery(".js-load").addClass("is-disabled");
    }
  }
}

PageSolrAdvanced.SHOW_SIMPLE_MODE_TOGGLER = false;
